<div class="with-floating-button">
    <div class="content">
        <list-view [liste]="listeOpeLogError" *ngIf="listeOpeLogError"></list-view>
    </div>
    <floating-button [listeActions]="listeActions"></floating-button>
</div>